import React from 'react';

class Faq extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
  }

  render() {
    return (
      <React.Fragment>
        <section
          id="faq"
          className="download-section pt-100 background-img"
          style={{
            backgroundImage: "url('img/app-hero-img.png')",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
            backgroundSize: "cover"
          }}
        >
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-lg-6">
                <h2 className="text-white">
                    Preguntas Frecuentes
                </h2>
                <div
                  id="accordion-1"
                  className="accordion accordion-faq pb-100"
                >
                  <div className="card">
                    <div
                      className="card-header py-4"
                      id="heading-1-4"
                      data-toggle="collapse"
                      role="button"
                      data-target="#collapse-1-4"
                      aria-expanded="false"
                      aria-controls="collapse-1-4"
                    >
                      <h6 className="mb-0">
                        <span className="ti-wallet mr-3"></span>
                        ¿Cómo funcionan los Grupos Frisbee?
                      </h6>
                    </div>
                    <div
                      id="collapse-1-4"
                      className="collapse"
                      aria-labelledby="heading-1-4"
                      data-parent="#accordion-1"
                    >
                      <div className="card-body">
                        <p>
                          Crea o únete a un Grupo para comprar el producto que más te guste. Cada Grupo puede esperar hasta por 72 horas para que el número de integrantes requerido haya realizado su compra. No se va hacer el cobro del dinero hasta que todos los integrantes hayan completado su compra.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div
                      className="card-header py-4"
                      id="heading-1-1"
                      data-toggle="collapse"
                      role="button"
                      data-target="#collapse-1-1"
                      aria-expanded="false"
                      aria-controls="collapse-1-1"
                    >
                      <h6 className="mb-0">
                        <span className="ti-pin mr-3"></span>
                        ¿En que ciudades tienen cobertura?
                      </h6>
                    </div>
                    <div
                      id="collapse-1-1"
                      className="collapse show"
                      aria-labelledby="heading-1-1"
                      data-parent="#accordion-1"
                    >
                      <div className="card-body">
                        <p>
                          Por el momento estamos con nuestro servicio solamente en la ciudad de Quito y Valles.
                          Muy pronto estaremos llegando a más ciudades del país, suscríbete a nuestra lista de clientes para
                          que te podamos comunicar cuando estemos en tu ciudad.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div
                      className="card-header py-4"
                      id="heading-1-2"
                      data-toggle="collapse"
                      role="button"
                      data-target="#collapse-1-2"
                      aria-expanded="false"
                      aria-controls="collapse-1-2"
                    >
                      <h6 className="mb-0">
                        <span className="ti-credit-card mr-3"></span>
                        ¿Qué métodos de pago tienen disponible?
                      </h6>
                    </div>
                    <div
                      id="collapse-1-2"
                      className="collapse"
                      aria-labelledby="heading-1-2"
                      data-parent="#accordion-1"
                    >
                      <div className="card-body">
                        <p>
                          Queremos darte toda la flexibilidad para que puedas hacer tus compras.
                          Puedes realizar tus pagos por: Transferencia Bancaria, Tarjeta de Crédito, Tarjeta de Débito y Pagos Contra Entrega.
                          Para participar en un Grupo Frisbee, tu pago solo puede ser por tarjeta.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div
                      className="card-header py-4"
                      id="heading-1-3"
                      data-toggle="collapse"
                      role="button"
                      data-target="#collapse-1-3"
                      aria-expanded="false"
                      aria-controls="collapse-1-3"
                    >
                      <h6 className="mb-0">
                        <span className="ti-gallery mr-3"></span>
                        ¿Cómo protegen la seguridad de mis datos?
                      </h6>
                    </div>
                    <div
                      id="collapse-1-3"
                      className="collapse"
                      aria-labelledby="heading-1-3"
                      data-parent="#accordion-1"
                    >
                      <div className="card-body">
                        <p>
                          Frisbee trabaja con un equipo muy profesional de ingenieros y aliados tecnológicos para proteger la seguridad de tus datos personales y de tu tarjetas.
                          Nunca vemos, editamos o guardamos los datos de tu tarjeta. Trabajamos con los mejores procesadores de pago del país, empresas 
                          con mucha experiencia en el mercado y que implementan estrategias de ciberseguridad iguales a las de un banco.
                          Siempre nos conectamos mediante una conexión segura SSL, aseguramos los datos con encripción de 256-bits y nunca vendemos, ni compartimos tu información personal con entidades ajenas a Frisbee sin tu consentimiento.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div
                      className="card-header py-4"
                      id="heading-1-5"
                      data-toggle="collapse"
                      role="button"
                      data-target="#collapse-1-5"
                      aria-expanded="false"
                      aria-controls="collapse-1-5"
                    >
                      <h6 className="mb-0">
                        <span className="ti-gallery mr-3"></span>
                        ¿Cómo funcionan los cambios y devoluciones?
                      </h6>
                    </div>
                    <div
                      id="collapse-1-5"
                      className="collapse"
                      aria-labelledby="heading-1-5"
                      data-parent="#accordion-1"
                    >
                      <div className="card-body">
                        <p>
                          Queremos darte todas las facilidades para que estés contenta con tu compra en Frisbee. 
                          Si lo que compraste no te gustó, no te quedó o solo no es lo que buscabas, te lo cambiamos sin ningún problema.
                          Desde tu App Frisbee puedes iniciar el proceso de Devolución, eliges una hora y fecha, y listo nosotros retiramos tu producto.
                          Puedes elegir una devolución de dinero o un cupón Frisbee por el valor de tu compra para comprar algo más.

                          No olvides que tienes 72 horas desde el momento que llegó tu producto para pedir una devolución sin ninguna condición adicional.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div className="col-md-4">
                <div className="download-img d-flex align-items-start">
                  <img
                    src="img/medios-de-pago.png"
                    alt="medios de pago frisbee"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default Faq;
